/**
 * Graceful image fade-in for image theme blocks.
 *
 * The hidden state is applied here rather than in CSS so images remain visible
 * when this script is blocked, fails to load, or never runs.
 * Safe to load multiple times.
 */
(() => {
  if (window.__meacoImageBlockBound) return;

  window.__meacoImageBlockBound = true;

  const CLASS = 'is-loading';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = (image) => image.classList.remove(CLASS);

  const enhance = (image) => {
    if (!(image instanceof HTMLImageElement)) return;
    if (image.dataset.imageEnhanced === 'true') return;

    // Settled images have already fired load or error, whether they succeeded
    // or broke, so hiding them here would be permanent.
    if (image.complete) return;

    image.dataset.imageEnhanced = 'true';
    image.classList.add(CLASS);

    image.addEventListener('load', () => reveal(image), { once: true });
    image.addEventListener('error', () => reveal(image), { once: true });
  };

  const enhanceAll = (root = document) => {
    if (reducedMotion.matches) return;

    root.querySelectorAll?.('.image-block__image').forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhanceAll(event.target);
  });
})();
